module.exports = __webpack_public_path__ + "img/handHello.aa42f39b.svg";